<template>
  <o-section
    :title="label || schema.verbose_name"
    not-closable
    :level="level + 1"
    body-classes="p-0"
  >
    <o-item-editable-table
      v-model="items"
      :default-new-value="newChild"
      :form-state="formState"
      :item-name="schema.verbose_name"
      @change="changed"
    >
      <template #o-headers>
        <th v-if="canSee(schema, 'group')">{{ schema.fields.group.label }}</th>
        <th v-if="canSee(schema, 'allow_view')">
          {{ schema.fields.allow_view.label }}
        </th>
        <th v-if="canSee(schema, 'allow_create')">
          {{ schema.fields.allow_create.label }}
        </th>
        <th v-if="canSee(schema, 'allow_update')">
          {{ schema.fields.allow_update.label }}
        </th>
      </template>
      <template #o-body="{ item, index }">
        <td v-if="canSee(schema, 'group')">
          <o-widget-wrapper
            :schema="schema"
            name="group"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-select
              v-model="items[index].group"
              :items="extendedOptionGroupItems"
              text-field="name"
              value-field="id"
              sort-field="name"
              :form-state="formState"
              :loading="optionGroupWorking"
              name="group"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.group"
              allow-add
              store-name="Group"
              add-title="Create New"
            >
              <template
                slot="form"
                slot-scope="{ item, formState, serverErrors }"
              >
                <group-form
                  :item="item"
                  :form-state="formState"
                  :server-errors="serverErrors"
                  in-modal
                ></group-form>
              </template>
            </o-select>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'allow_view')">
          <o-widget-wrapper
            :schema="schema"
            name="allow_view"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-checkbox
              v-model="items[index].allow_view"
              :form-state="formState"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.allow_view"
            ></o-checkbox>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'allow_create')">
          <o-widget-wrapper
            :schema="schema"
            name="allow_create"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-checkbox
              v-model="items[index].allow_create"
              :form-state="formState"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.allow_create"
              v-if="items[index].group > 0"
            ></o-checkbox>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'allow_update')">
          <o-widget-wrapper
            :schema="schema"
            name="allow_update"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-checkbox
              v-model="items[index].allow_update"
              :form-state="formState"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.allow_update"
            ></o-checkbox>
          </o-widget-wrapper>
        </td>
      </template>
    </o-item-editable-table>
  </o-section>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import schema from "../../schema/index.js";
import { cleanUpModel } from "@/vue-ocom/schema/schema_vuetify.js";
import { CreateDefaultItem } from "@/vue-ocom/schema/schema_utils.js";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  UseCodeModulesMixin,
} from "@/vue-ocom/mixins";
import OItemEditableTable from "@/vue-ocom/components/table/OItemEditableTable.vue";
import OSection from "@/vue-ocom/components/layout/OSection.vue";

export default {
  name: "FormTemplatePermissionFormTable",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("FormTemplatePermission"),
    UseCodeModulesMixin(["FormTemplateVersion", "Group"]),
  ],
  components: { OItemEditableTable, OSection },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.FormTemplatePermission,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.FormTemplatePermission),
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
  },
  computed: {
    extendedOptionGroupItems() {
      var items = this.optionGroupItems;

      return [
        ...items,
        {
          id: -1,
          name: "Creator",
          permissions: [],
          pk: -1,
        },
        {
          id: -2,
          name: "Submitter",
          permissions: [],
          pk: -2,
        },
        {
          id: -3,
          name: "Task Assigned",
          permissions: [],
          pk: -3,
        },
      ];
    },
  },
  created() {
    // this.loadCodeTables()
  },
};
</script>
